import React from 'react';
import {
  TextInput,
  DateInput,
  NumberInput,
  BooleanInput,
  required,
} from 'react-admin';
import { Grid, Paper, Typography, Box } from '@mui/material';

export const InsuranceForm = () => (
  <Box sx={{ width: '100%', maxWidth: 900 }}>
    {/* Basic Information */}
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
        Policy Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextInput
            source="policyNumber"
            validate={[required()]}
            fullWidth
            label="Policy Number"
            helperText="Unique policy identifier"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            source="insurerName"
            validate={[required()]}
            fullWidth
            label="Insurance Company"
            helperText="Name of the insurance provider"
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source="policyName"
            fullWidth
            label="Policy Name"
            helperText="Optional friendly name for this policy"
          />
        </Grid>
      </Grid>
    </Paper>

    {/* Coverage Dates */}
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
        Coverage Period
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <DateInput
            source="effectiveDate"
            validate={[required()]}
            fullWidth
            label="Effective Date"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DateInput
            source="expiryDate"
            validate={[required()]}
            fullWidth
            label="Expiry Date"
          />
        </Grid>
        <Grid item xs={12}>
          <BooleanInput
            source="active"
            label="Active"
            helperText="Uncheck to deactivate this insurance policy"
          />
        </Grid>
      </Grid>
    </Paper>

    {/* Coverage Details */}
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
        Coverage Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <NumberInput
            source="liabilityLimit"
            fullWidth
            label="Liability Limit"
            helperText="Maximum liability coverage in dollars"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput
            source="collisionDeductible"
            fullWidth
            label="Collision Deductible"
            helperText="Deductible for collision coverage"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput
            source="comprehensiveDeductible"
            fullWidth
            label="Comprehensive Deductible"
            helperText="Deductible for comprehensive coverage"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput
            source="allPerilsDeductible"
            fullWidth
            label="All Perils Deductible"
            helperText="Combined collision + comprehensive + extra coverage"
          />
        </Grid>
      </Grid>
    </Paper>

    {/* Additional Information */}
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
        Additional Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <TextInput
            source="notes"
            fullWidth
            multiline
            rows={6}
            label="Notes"
            helperText="Additional notes about this policy"
          />
        </Grid>
      </Grid>
    </Paper>
  </Box>
);
